import { useTranslation } from 'react-i18next';
import type { Hint } from '../../types/game';

interface HintListProps {
  hints: Hint[];
  checkedHints: string[];
  onToggleHint: (id: string) => void;
  visibleDay: number;
}

const TYPE_ICON: Record<string, string> = {
  arithmetic: '∑',
  color: '●',
  behavior: '👁',
  sheriff: '★',
  parity: '⚖',
};

export function HintList({ hints, checkedHints, onToggleHint, visibleDay }: HintListProps) {
  const { t } = useTranslation('game');

  const visibleHints =
    visibleDay === 0 ? hints : hints.filter((h) => !h.revealedAtDay || h.revealedAtDay <= visibleDay);

  return (
    <div className="flex flex-col gap-2">
      <h4 className="font-mono text-xs tracking-widest uppercase text-mafia-muted">
        {t('board.hints.title')}
      </h4>
      {visibleHints.map((hint) => {
        const isUsed = checkedHints.includes(hint.id);
        return (
          <label
            key={hint.id}
            className={`
              flex items-start gap-2.5 cursor-pointer group
              ${isUsed ? 'opacity-50' : ''}
            `}
          >
            <input
              type="checkbox"
              checked={isUsed}
              onChange={() => onToggleHint(hint.id)}
              className="mt-0.5 accent-mafia-gold shrink-0"
            />
            <div className="flex flex-col gap-0.5">
              <span className="text-[9px] font-mono text-mafia-muted uppercase tracking-widest">
                {TYPE_ICON[hint.type] ?? '◆'} {hint.type}
              </span>
              <span className={`text-xs leading-relaxed ${isUsed ? 'line-through text-mafia-muted' : 'text-mafia-paper'}`}>
                {hint.text}
              </span>
            </div>
          </label>
        );
      })}
    </div>
  );
}
